module.exports = __webpack_public_path__ + "media/organizations/FOM-4cdf1e72.webp";